import {
  appFormUtil,
  useAccessState
} from 'modules/common';
import { StyledDropDown } from 'modules/components/layer01';
import React from 'react';
import * as ds from './dataService';


export type SelectTaskCategoryFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: SelectTaskCategoryFieldProps<T>) => {
  const { data } = ds.useQuery();
  const access = useAccessState('TaskCategory');
  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      disabled={!access.update}
      options={[...data]}
    />
  );
};
